export default {
  header: 'Close Unsaved Design',
  content: 'This estimate is not yet saved to your account. If you close this estimate, you will lose your changes.',
  buttonText: 'Close Without Saving',
};
